import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { DemoDataService } from '../services/demo-data.service';

@Injectable()
export class DemoInterceptor implements HttpInterceptor {
  private demoDataService = inject(DemoDataService);
  private router = inject(Router);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const currentUrl = new URL(window.location.href);
    const isDemoMode = currentUrl.searchParams.get('demo') === 'true';
    const isDebuggerMode = currentUrl.searchParams.get('debugger') === 'true';

    if (isDebuggerMode) {
      console.log('DemoInterceptor - URL:', req.url);
      console.log('DemoInterceptor - Current URL:', window.location.href);
      console.log('DemoInterceptor - Demo Mode:', isDemoMode);
    }

    if (isDemoMode) {
      console.log('DemoInterceptor - Intercepting request with fake data');
      return this.handleDemoRequest(req);
    }

    if (isDebuggerMode) {
      console.log('DemoInterceptor - Passing through to real API');
    }
    return next.handle(req);
  }

  private handleDemoRequest(
    req: HttpRequest<unknown>
  ): Observable<HttpEvent<unknown>> {
    const fakeResponse = this.demoDataService.getFakeResponse(
      req.url,
      req.method
    );

    return of(
      new HttpResponse({
        status: 200,
        statusText: 'OK',
        body: fakeResponse,
        url: req.url,
      })
    );
  }
}
